export type InventoryHealth = {
  connected: boolean
  provider: string
  datacenter?: string
  reason?: string
}

export async function getInventoryHealth(): Promise<InventoryHealth> {
  try {
    const res = await fetch('/api/inventory/health')
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return (await res.json()) as InventoryHealth
  } catch {
    return { connected: false, provider: 'unknown', reason: 'network_error' }
  }
}

